import { useTheme } from 'next-themes';
import { Toaster as SonnerToaster } from 'sonner';

type ToasterProps = React.ComponentProps<typeof SonnerToaster>;

export function Toaster(props: Partial<ToasterProps>) {
  const { theme = 'system' } = useTheme();

  return (
    <SonnerToaster
      theme={theme as ToasterProps['theme']}
      position="top-center"
      expand={false}
      closeButton
      richColors
      duration={3000}
      gap={12}
      visibleToasts={3}
      style={{ top: 'var(--sat)' }}
      toastOptions={{
        classNames: {
          toast: 'pointer-events-auto bg-transparent p-0 shadow-none',
          closeButton: 'toast-close-muted',
        },
      }}
      {...props}
    />
  );
}
